import React, { useCallback } from "react";
import { Modal } from "../modal/Modal";
import { CloseButton } from "../input/CloseButton";
import { FormattedMessage } from "react-intl";
import { Column } from "../layout/Column";
import styles from "./NotPermissionModal.scss";
import { Button } from "@fluentui/react-components";

export function ObjectNotPermissionModal({ scene, entry, onSpawn, onClose }) {
  return (
    <Modal
      afterTitleClassName={styles.closeDialog}
      afterTitle={<CloseButton onClick={onClose} className={styles.closeDialog} />}
      headerClassName={styles.header}
      className={styles.modalContainer}
    >
      <Column className={styles.column} padding center>
        <div>
          <h3 className={styles.title}>
            <FormattedMessage id="scene-permission-modal.assets" defaultMessage="Upload Assets" />
          </h3>

          <p className={styles.text}>
            <FormattedMessage
              id="scene-permission-modal.text"
              defaultMessage="You don't have permissions to upload assets in this room. Please contact the host to grant you the necessary permissions."
            />
          </p>
        </div>
        <Button onClick={onClose} preset="primary" className={styles.mediaModalButton}>
          <FormattedMessage id="scene-permission-modal.continue" defaultMessage="Continue" />
        </Button>
      </Column>
    </Modal>
  );
}
